import Vue from 'vue';
import Vuex from 'vuex';
import ajax from "../plugins/ajax";
// import config from "../config";
import md5 from "md5";

Vue.use(Vuex);

/**
 * storage 存储
 */
export const storage = {
  /**
   * 获取
   * @param key
   * @returns {string|null}
   */
  getItem(key) {
    let data = localStorage.getItem(key);
    if (data) {
      return data;
    } else {
      return null;
    }
  },

  /**
   * 设置
   * @param key
   * @param content
   */
  setItem(key, content) {
    if (typeof content == 'object') {
      return localStorage.setItem(key, JSON.stringify(content));
    } else {
      return localStorage.setItem(key, content);
    }
  },

  /**
   * 移除
   * @param key
   */
  removeItem(key) {
    return localStorage.removeItem(key);
  }
};

export default new Vuex.Store({
  state: {
    doc: null,
    password: '',
  },
  mutations: {},
  actions: {
    /**
     * 数据初始化
     * @param context
     */
    init(context) {
      return new Promise((resolve) => {
        if (!context.state.password) {
          let password = storage.getItem('password');
          if (password) {
            context.state.password = password;
          }
          resolve();
        } else {
          resolve();
        }
      });
    },
    login(context, password) {
      password = md5(password);
      storage.setItem('password', password);
      context.state.password = password;
      return context.dispatch('checkPassword');
    },
    logout(context){
      storage.removeItem('password');
      context.state.password = '';
      return context.dispatch('checkPassword');
    },
    checkPassword(context) {
      return ajax.getJSON('__status.json', {
        password: context.state.password,
      });
    },
  },
  modules: {}
})
